module.exports = __webpack_public_path__ + "src/assets/img/advert-default.77b3adf8.png";